<template>
<div>
<div v-if="sysBookingNum" class="">
    
                                <div class="title "> 
                                     {{status=='Today'?$t('dashBoard.cAgtDBTotalBookings.todayBooking'):status=='Month'?
                                     $t('dashBoard.cAgtDBTotalBookings.monthlyBooking'):status=='Week'?
                                     $t('dashBoard.cAgtDBTotalBookings.weeklyBooking'):$t('dashBoard.cAgtDBTotalBookings.booking')}} </div>
                                
                                <div  class="grap-wrap" style="padding: 10px;">
                                   
                                   <CChartDoughnut :dataSets="dataSets" :chartLabels="chartLabel"></CChartDoughnut>
                                </div>
                               
                                <div class=" count-wrap">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-4 col-xs-4">
                                            <div class="label-box-outline blue">

                                            </div>
                                            <div class="number"> {{Math.round(sysBookingNum.ticketingqueuepercent)+'%'}}</div>
                                            <div class="text"> {{$t('dashBoard.cAgtDBTotalBookings.ticketingQueue')}} </div>
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-4">
                                            <div class="label-box-outline green">

                                            </div>
                                            <div class="number"> {{Math.round(sysBookingNum.issuedbookingspercent)+'%'}}</div>
                                            <div class="text"> {{$t('dashBoard.cAgtDBTotalBookings.issuedBookings')}}</div>
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-4">
                                            <div class="label-box-outline red">

                                            </div>
                                            <div class="number"> {{Math.round(sysBookingNum.failedbookingspercent)+'%'}}</div>
                                            <div class="text"> {{$t('dashBoard.cAgtDBTotalBookings.failedBookings')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
</div>

</template>
<script>
import Logger from "../../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../../router/index";
import apiAgentSales from "./../../../../services/apiAgentSales";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import cMonthDropdown from "../../../../components/form/cMonthDropdown";
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base.js";
import SERVICE_URL from "../../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue,groupBy } from "../../../../util/util";
import CChartDoughnut from "../../../chart/CChartDoughnut"
export default {
  name: COMPONENT_NAME.C_AGT_DB_TOTAL_BOOKINGS,

  components:{
      cMonthDropdown,
      CChartDoughnut
  },

  data () {
    return {
      dataSets:[],
      chartLabel:[]
    }
   },
   props:{
       sysBookingNum:{
           type: Object,
           default:null
       },
       status:{
           type: String,
           default:null
       },
   },

//    computed: {
//            ...mapGetters("sSysLogin", {
//       ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
//     }),
//         },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                // if ( this.sysBookingNum) {
                   
                    this.dataSets = this.toGetDataSets(this.sysBookingNum);
                    

                // }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGT_DB_TOTAL_BOOKINGS,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

  methods: {

      showAlert(val) {
                this.$emit("showAlert", val);
            },

      toGetDataSets(pSysBookingNo) {
          
          let retValue=[];
          
          try {
            if(BaseConfiguration.isDebug) console.log("toGetTotalSales");
            if(pSysBookingNo ) {
                if(pSysBookingNo.ticketingqueuepercent) {
                retValue.push(Math.round(pSysBookingNo.ticketingqueuepercent))
                }
                if(pSysBookingNo.issuedbookingspercent) {
                retValue.push(Math.round(pSysBookingNo.issuedbookingspercent))
                }
                if(pSysBookingNo.failedbookingspercent) {
                retValue.push(Math.round(pSysBookingNo.failedbookingspercent))
                }
                if(pSysBookingNo.ticketingqueue) {
                this.chartLabel.push([this.$t('dashBoard.cAgtDBTotalBookings.noOfTicketing')+' :'+Math.round(pSysBookingNo.ticketingqueue)])
                }
                if(pSysBookingNo.issuedbookings) {
                this.chartLabel.push([this.$t('dashBoard.cAgtDBTotalBookings.noOfIssued')+' :'+ Math.round(pSysBookingNo.issuedbookings)])
                }
                if(pSysBookingNo.failedbookingscount) {
                this.chartLabel.push([this.$t('dashBoard.cAgtDBTotalBookings.noOfFailed')+' :'+Math.round(pSysBookingNo.failedbookingscount)])
                }
                
                }
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGT_DB_TOTAL_BOOKINGS,
                    "error in toGetTotalSales",
                    err.toString(),
                    "toGetTotalSales",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
    }, 

       
  }
}

</script>
<style>
    main.c-main {
        background: #f2f4f5;
    }
</style>